export default __webpack_public_path__ + "static/media/blob_left.6b7660f6.svg";